import { useEffect } from "react";
import { Box, Button, Chip, Typography } from "@mui/material";
import { HandshakeIcon, UserRoundPlus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import FlexBox from "components/common/FlexBox";
import { useListMemberDelegationTasks } from "services/delegation";
import {
  getStatusColor,
  getStatusLabel,
} from "components/delegation/DelegationCard";
import useIsMobile from "components/hooks/useIsMobile";

const MAX_VISIBLE = 3;

export default () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { request, data, loading } = useListMemberDelegationTasks();

  useEffect(() => {
    request();
  }, []);

  const tasks = data?.delegationTasks ?? [];
  const visibleTasks = tasks.slice(0, MAX_VISIBLE);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <FlexBox direction="row" justifyContent="space-between">
        <FlexBox direction="row" gap="8px" alignItems="center">
          <HandshakeIcon size={20} color="#198282" />
          <Typography variant={isMobile ? "h3" : "h4"}>
            Helping Hands
          </Typography>
        </FlexBox>
        <Button
          variant="text"
          sx={{ height: "auto", minWidth: "unset" }}
          onClick={() => navigate("/delegations")}
        >
          See all
        </Button>
      </FlexBox>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        {!loading && tasks.length === 0 && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              padding: "16px",
              borderRadius: "12px",
              border: "2px dashed #D4D4D4",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <UserRoundPlus size={20} color="#9E9E9E" />
              <Typography variant="body" fontWeight={600}>
                No tasks delegated yet
              </Typography>
            </Box>
            <Typography
              variant="bodySmall"
              color="text.secondary"
              noWrap
              sx={{ cursor: "pointer" }}
              onClick={() =>
                navigate("/conversations/in-app", {
                  state: {
                    prefill: "Book me a dinner reservation for Saturday",
                  },
                })
              }
            >
              <Box
                component="span"
                sx={{ color: "primary.main", fontWeight: 700 }}
              >
                Try
              </Box>{" "}
              &ldquo;Book me a dinner reservation for Saturday&rdquo;
            </Typography>
          </Box>
        )}
        {visibleTasks.map((task) => (
          <Box
            key={task.ref}
            title={task.title}
            onClick={() =>
              navigate(`/delegations/${encodeURIComponent(task.ref)}`)
            }
            sx={(theme) => ({
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "8px 12px",
              borderRadius: "10px",
              border: `1px solid ${theme.palette.gray[4]}`,
              cursor: "pointer",
              overflow: "hidden",
            })}
          >
            <Typography variant="body" noWrap sx={{ flex: 1, minWidth: 0 }}>
              {task.title}
            </Typography>
            <Chip
              label={getStatusLabel(task.status)}
              color={getStatusColor(task.status)}
              size="small"
              sx={{ flexShrink: 0 }}
            />
          </Box>
        ))}
        {tasks.length > MAX_VISIBLE && (
          <Button
            variant="text"
            sx={{ alignSelf: "center", height: "unset" }}
            onClick={() => navigate("/delegations")}
          >
            See more
          </Button>
        )}
      </Box>
    </Box>
  );
};
